import { Pipe, PipeTransform } from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { DEFAULT_CHANNEL_CODE } from '@vendure/common/lib/shared-constants';
import { OrderLine } from '../../common/generated-types';

@Pipe({
  name: 'quantity',
})
export class LineQuantityPipe implements PipeTransform {
  transform(value: OrderLine): any {
    if (!value) {
      return '';
    }
    let unitMultiplier = 1;
    const unit = value.customFields.unitOfMeasure.match(/\d+/);
    if (unit && unit[0]) {
      unitMultiplier = unit[0];
    }
    return value.quantity / unitMultiplier;
  }
}
